export default __webpack_public_path__ + "static/media/doowon.748a67ba.png";